import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { BRAND } from "@/lib/brand";

const links = [
  { href: "#services", label: "Services" },
  { href: "#about", label: "L'atelier" },
  { href: "#testimonials", label: "Avis" },
  { href: "#contact", label: "Devis" },
  { href: "#location", label: "Accès" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-black/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        <a href="#top" className="flex items-center gap-3" data-testid="navbar-logo">
          <img src={BRAND.logo} alt="LAD Performance" className="h-12 w-12 object-contain" />
          <div className="hidden sm:block leading-none">
            <div className="font-display text-xl text-white tracking-wide">LAD PERFORMANCE</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-yellow-500 mt-1">
              Préparation · E85
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="text-sm uppercase tracking-widest text-zinc-300 hover:text-yellow-500 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${BRAND.phoneRaw}`}
            data-testid="navbar-phone-cta"
            className="hidden md:inline-flex items-center gap-2 bg-yellow-500 hover:bg-yellow-400 text-black px-5 py-3 font-medium text-sm uppercase tracking-wider transition-colors"
          >
            <Phone className="w-4 h-4" />
            {BRAND.phone}
          </a>
          <button
            data-testid="navbar-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-white"
            aria-label="Menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-black border-t border-white/10" data-testid="navbar-mobile-menu">
          <nav className="flex flex-col px-6 py-6 gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base uppercase tracking-widest text-zinc-200 hover:text-yellow-500"
              >
                {l.label}
              </a>
            ))}
            <a
              href={`tel:${BRAND.phoneRaw}`}
              className="inline-flex items-center gap-2 bg-yellow-500 text-black px-5 py-3 font-medium text-sm uppercase tracking-wider mt-2 w-fit"
            >
              <Phone className="w-4 h-4" />
              {BRAND.phone}
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
